<template>
  <!-- <AuthForms /> -->
  <div
    v-if="
      !globalStore.underConstructionActive ||
      (typeof getCookie('under-construction-validated') !== undefined &&
        getCookie('under-construction-validated') == 'yes')
    "
    id="global-wrapper"
    class="global-wrapper"
    :class="[
      currentRouteName,
      { 'not-logged-in': !isAuthenticated, 'logged-in': isAuthenticated },
      userLevel,
      { 'app-wrapper': !globalStore.landingsPage && isAuthenticated }
    ]"
  >
    <metainfo></metainfo>
    <MetaManager />

    <transition name="fade">
      <WebsiteHeader v-if="!isAuthenticated || globalStore.landingsPage" />
    </transition>

    <transition name="fade">
      <Header v-if="isAuthenticated && !globalStore.landingsPage" />
    </transition>
    <main>
      <LoadingOverlay />
      <router-view :key="$route.fullPath" />
    </main>
    <transition name="fade">
      <Footer v-if="!isAuthenticated || globalStore.landingsPage" />
    </transition>
  </div>
  <div v-else class="global-under-construction-wrapper">
    <UnderConstruction />
  </div>
</template>

<script>
//Vue
import { defineComponent, computed, ref, watch, onMounted } from 'vue'

//Lib
import {
  getData,
  OauthAuthenticate,
  fetchEnumFlatValues,
  getUserProfile,
  getUserToken,
  fetchUserFavoriteVideos,
  fetchCustomerGroupList
} from '@streampac.io/chef_sp_1'

import { useRoute, useRouter } from 'vue-router'

import { useMeta } from 'vue-meta'

//Composables
import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useCurrentUserData } from '@/composables/useUserData'

//Components
// import AuthForms from '@/components/AuthForms/index.vue'
import Header from '@/components/Header/index.vue'
import WebsiteHeader from '@/components/WebsiteHeader/index.vue'
import Footer from '@/components/Footer/index.vue'
import UnderConstruction from '@/views/UnderConstruction/index.vue'
import LoadingOverlay from '@/components/LoadingOverlay/index.vue'
import MetaManager from '@/components/MetaManager/index.vue'

import { useGlobalStore } from '@/stores/global'
import { isAuthenticated } from './utils/global'

export default defineComponent({
  components: {
    Header,
    WebsiteHeader,
    Footer,
    UnderConstruction,
    // AuthForms,
    LoadingOverlay,
    MetaManager
  },
  setup() {
    const globalStore = useGlobalStore()

    useAuthenticationData().setAuthenticated(getData('loginData') ? true : false)

    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const { getCurrentUser, getCurrentUserProfile, refreshUserData } = useCurrentUserData()

    const userLevel = computed(() => {
      return 'user-level-test'

      // if (isAuthenticated.value) {
      //     if (getCurrentUser.value?.level == 1) {
      //         return 'user-hbo';
      //     } else if (getCurrentUser.value?.level == 2) {
      //         return 'user-mbo';
      //     } else {
      //         return null;
      //     }
      // } else {
      //     return null;
      // }
    })

    const currentRouteName = computed(() => {
      if ($route.name) {
        return $route.name.toLowerCase()
      } else {
        return false
      }
    })

    const savedToken = ref(null)

    const $route = useRoute()
    const $router = useRouter()

    //refs
    const resolvedOAuthState = ref(null)

    watch(
      () => isAuthenticated.value,
      (val) => {
        if (val && val === true) {
          //saveUserFavorites()
          saveUserProfile()
        }

        refreshUserData()
      }
    )

    watch(
      () => $route.path,
      () => {
        window.scrollTo(0, 0)
        globalStore.doTriggerFavoriteFetch()
      }
    )

    useMeta({
      title: 'Future Proof Scan',
      description: '',
      link: [
        {
          rel: 'canonical',
          href: globalStore.getProductionWebsiteUrl + $route.path
        }
      ]
      // htmlAttrs: {
      //     lang: 'en',
      //     amp: true
      // }
    })

    // watch(() => getCurrentUserProfile.value, () => {

    //     if (getCurrentUserProfile.value) {
    //         if (!getCurrentUserProfile.value?.aboutMe || getCurrentUserProfile.value?.aboutMe && getCurrentUserProfile.value?.aboutMe == '') {

    //             if ($route.path !== '/profiel/instellingen') {
    //                 $router.push({
    //                     path: '/profiel/instellingen',
    //                     query: {
    //                         'just-registered': true
    //                     }
    //                 });
    //             }

    //         }
    //     }

    // }, { deep: true });

    function checkLoggedInPages() {
      if ($route.name !== 'Login' && $route.name !== 'ActivateAccount') {
        return true
      }

      return false
    }

    function getCookie(cname) {
      let name = cname + '='
      let ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }

    function saveEnumLookup() {
      fetchEnumFlatValues(isAuthenticated.value).then((response) => {
        globalStore.saveEnumLookup(response)
      })
    }

    saveEnumLookup()

    function saveUserProfile() {
      if (isAuthenticated.value) {
        getUserToken((token) => {
          savedToken.value = token
        })
      }
    }

    saveUserProfile()

    watch(
      () => globalStore.getUserProfile,
      () => {
        const getUserProfile = globalStore.getUserProfile

        if (isAuthenticated.value && getUserProfile) {
          const params = {
            userId: getUserProfile.userId,
            flattenFields: false,
            getUnpublishVideosToo: false
          }

          fetchUserFavoriteVideos(isAuthenticated.value, params).then((response) => {
            if (response) {
              globalStore.saveUserFavoriteVideos(response)
            }
          })
        }
      }
    )

    function handleOAuth() {
      const searchParams = new URLSearchParams(window.location.search)

      if (searchParams.has('code')) {
        let inputData = {}

        let stdCallback = window.location.origin + '/'
        let stdSocial = 0

        if (searchParams.has('state')) {
          if (searchParams.get('state')) {
            const getOAuthState = searchParams.get('state')
            resolvedOAuthState.value = JSON.parse(atob(getOAuthState))

            stdSocial = resolvedOAuthState.value.social_type
          }
        }

        inputData = {
          code: searchParams.get('code'),
          customerId: import.meta.env.VITE_API_CUSTOMER_ID,
          callbackUrl: stdCallback,
          type: stdSocial
        }

        OauthAuthenticate(inputData, (response) => {
          //Login failed
          if (response.status == 400 || response.succes == false) {
            useAuthenticationData().setAuthenticated(false)

            // this.loginError = true
            // this.user.username = ''
            // this.user.password = ''
          } else {
            useAuthenticationData().setAuthenticated(true)
            // this.loginError = false

            globalStore.storeSetAuthenticated()

            if ($route.name == 'RegisterPage') {
              $router.replace({ name: 'Home' })
            } else {
              //Redirect user to previous page
              if (
                resolvedOAuthState.value &&
                resolvedOAuthState.value.user_redirect &&
                resolvedOAuthState.value.user_redirect !== ''
              ) {
                window.location.href = resolvedOAuthState.value.user_redirect
              }
            }
          }
        })
      }
    }

    handleOAuth()

    function fetchCustomerGroupIds() {
      const fetchDataParams = {
        filter: {
          searchTerm: ''
        },
        paging: {
          pageNumber: 1,
          pageSize: 100
        },
        flattenFields: true
      }

      fetchCustomerGroupList(isAuthenticated.value, fetchDataParams, true).then((response) => {
        if (response?.status === 200) {
          globalStore.saveCustomerGroupLookup(response.data)
        }
      })
    }

    fetchCustomerGroupIds();

    // Initialize loader state from localStorage
    onMounted(() => {
      const loaderEnabled = localStorage.getItem('loader-enabled')
      if (loaderEnabled === 'false') {
        globalStore.disableLoader()
        console.log('Loader is disabled globally')
      }
    })

    return {
      globalStore,
      isAuthenticated,
      currentRouteName,
      userLevel,
      //metaInfo,
      //functions
      checkLoggedInPages,
      getCookie
    }
  }
})
</script>

<style lang="scss">
// @import styles
@import './assets/scss/global.scss';
@import './assets/scss/responsive-global.scss';
</style>
